import React from 'react';
import styled, { css } from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { Icon } from '../Icon';

interface TableToggleButtonProps {
  label: string;
  onClick: () => void;
  isActive?: boolean;
  className?: string;
}

const Layout = styled.button.attrs({
  type: 'button',
})`
  position: relative;
  z-index: ${theme.zIndex.content + 50};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: auto;
  height: ${toRem(25)};
  padding: 0 ${toRem(theme.space.md)};
  border-radius: ${toRem(12.5)};
  background-color: ${theme.color.neutral[100]};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  color: ${theme.color.neutral[900]};
  transition: background-color ${theme.transition.button.default};
  pointer-events: all;

  &:hover {
    background-color: ${theme.color.neutral[100]};
  }

  @media (min-width: ${theme.breakpoint.med}px) {
    position: relative;
    top: auto;
    right: auto;
  }
`;

const IconWrapper = styled.span<Partial<TableToggleButtonProps>>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  margin-left: ${toRem(theme.space.sm)};
  transform: rotateZ(0deg);
  transition: all ${theme.transition.icon};

  svg {
    fill: ${theme.color.neutral[200]};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      transform: rotateZ(180deg);
    `}
`;

const TableToggleButton: React.FC<TableToggleButtonProps> = ({ label, onClick, isActive, className }) => (
  <Layout className={className} onClick={onClick} aria-label={`Click to ${isActive ? 'hide' : 'show'} details.`}>
    {label}
    <IconWrapper isActive={isActive}>
      <Icon icon="Carrot" width={6} height={4} />
    </IconWrapper>
  </Layout>
);

export default TableToggleButton;
